import logo from './img/logo-smaller.png';
import bioPhoto from './img/me.jpeg';
import './App.css';
import Header from './components/Header';
import Education from './components/Education';
import Contact from './components/Contact';
import Services from './components/Services';
import About from './components/About';
import Portfolio from './components/Portfolio';
import PortfolioProjectCategory from './components/PortfolioProjectCategory';
import Project from './components/Project';

import Skills from './components/Skills';
import Introduction from './components/Introduction';
import Loading from './components/Loading';
import Home from './components/Home';
import { useState } from 'react';
import Background from './components/Background';


import Layout from "./components/pages/Layout";
import NoPage from "./components/pages/NoPage";

import {
  BrowserRouter as Router,
  Route, Routes, Navigate, Outlet, useLocation
} from "react-router-dom";
import { AdminProvider, useAdmin } from "./admin/AdminContext";
import AdminLayout from "./admin/AdminLayout";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import AdminAbout from "./admin/AdminAbout";
import AdminEducation from "./admin/AdminEducation";
import AdminMessages from "./admin/AdminMessages";
import AdminChatConversations from "./admin/AdminChatConversations";
import AdminSettings from "./admin/AdminSettings";
import AdminPassword from "./admin/AdminPassword";
import AdminServices from "./admin/AdminServices";
import AdminSkills from "./admin/AdminSkills";
import AdminProjects from "./admin/AdminProjects";

function AdminRequireAuth() {
  const { user, loading } = useAdmin();
  const location = useLocation();
  if (loading) return <div className="admin-app" style={{ padding: '2rem', textAlign: 'center' }}>Loading…</div>;
  if (!user) return <Navigate to="/admin/login" state={{ from: location }} replace />;
  return <Outlet />;
}
function App() {
  const year =new Date().getFullYear();
  const copyright = "Copyright 2020 - "+year+" © - All Rights Reserved"
  const pageList =[{id:1,title: "HOME",uri:'/'},{id:2,title: "ABOUT",uri:'/about'},{id:3,title: "SERVICES",uri:'/services'},
  {id:4,title: "SKILLS",uri:'/skills'},{id:5,title: "PORTFOLIO",uri:'/portfolio'},{id:6,title: "LET'S TALK",uri:'/contact'}]

  const [serviceSelected,setServiceSelected] = useState([]);
  const [refreshPage,setRefreshPage] = useState(false);


  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout logo={logo}  
      pageList={pageList} />}>
          <Route index  element={  <Introduction pageList={pageList} refreshPage={refreshPage}/> }>   
          </Route>
          <Route path="menu"  element={  <Home  pageList={pageList} refreshPage={refreshPage}/> }>   
          </Route>
          <Route path="about" element={ <About  pageList={pageList}  refreshPage={refreshPage}/>} />
          <Route path="services" element={  <Services  pageList={pageList}  refreshPage={refreshPage}/>
        } />
          <Route path="skills" element={  <Skills  pageList={pageList}  refreshPage={refreshPage}/>
       } />
          <Route path="portfolio" element={<Portfolio  pageList={pageList}  refreshPage={refreshPage}/>} />

          {/* Route for 'portfolio/something' */}
          <Route path="portfolio/:category" element={<PortfolioProjectCategory  pageList={pageList}  refreshPage={refreshPage}/>} />

          {/* Route for 'portfolio/something/another' */}
          <Route path="portfolio/:category/:project" element={<Project  pageList={pageList} refreshPage={refreshPage} projectSelected = {""}/>} />

          <Route path="projects" element={<Portfolio pageList={pageList}  refreshPage={refreshPage}/>} />

        {/* Route for 'portfolio/something' */}
        <Route path="projects/:category" element={<PortfolioProjectCategory  pageList={pageList} refreshPage={refreshPage}/>} />

        {/* Route for 'portfolio/something/another' */}
        <Route path="projects/:category/:project" element={<Project  pageList={pageList}  refreshPage={refreshPage} projectSelected = {""}/>} />

        <Route path="education" element={   <Education pageList={pageList}  serviceSelected= {serviceSelected} refreshPage={refreshPage}/>
     } />


          <Route path="contact" element={   <Contact  pageList={pageList} serviceSelected= {serviceSelected} refreshPage={refreshPage}/>
     } />
          <Route path="*" element={<NoPage />} />
        </Route>

        <Route path="admin" element={<AdminProvider />}>
          <Route path="login" element={<AdminLogin />} />
          <Route element={<AdminRequireAuth />}>
            <Route element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="about" element={<AdminAbout />} />
              <Route path="services" element={<AdminServices />} />
              <Route path="skills" element={<AdminSkills />} />
              <Route path="projects" element={<AdminProjects />} />
              <Route path="projects/:projectId" element={<AdminProjects />} />
              <Route path="education" element={<AdminEducation />} />
              <Route path="messages" element={<AdminMessages />} />
              <Route path="chats" element={<AdminChatConversations />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="password" element={<AdminPassword />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
